import React, { useState, useEffect } from "react";
import api from "../services/api";
import toast from "react-hot-toast";

export default function Formulaires() {
  const [forms, setForms] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ titre:"", description:"", champs:[] });
  const [editing, setEditing] = useState(null);
  const TYPES = ["text","number","date","select","textarea","checkbox"];

  const load = () => api.get("/formulaires").then(r => setForms(r.data));
  useEffect(() => { load(); }, []);

  const addChamp = () => setForm({...form, champs: [...form.champs, { nom:"", label:"", type:"text", required:false, options:"" }]});
  const updateChamp = (i, k, v) => { const c=[...form.champs]; c[i]={...c[i],[k]:v}; setForm({...form,champs:c}); };
  const removeChamp = i => { const c=[...form.champs]; c.splice(i,1); setForm({...form,champs:c}); };

  const submit = async e => {
    e.preventDefault();
    try {
      if (editing) { await api.put(`/formulaires/${editing.id}`, form); toast.success("Modifié"); }
      else { await api.post("/formulaires", form); toast.success("Formulaire créé"); }
      setShowForm(false); load();
    } catch(e) { toast.error("Erreur"); }
  };

  return (
    <div style={{ padding:32 }}>
      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:24 }}>
        <h1 style={{ fontSize:24, fontWeight:800, color:"#1B3A8C" }}>Formulaires</h1>
        <button onClick={() => { setShowForm(true); setEditing(null); setForm({ titre:"", description:"", champs:[] }); }}
          style={{ background:"#1B3A8C", color:"#fff", border:"none", borderRadius:8, padding:"10px 20px", fontWeight:700, cursor:"pointer" }}>
          + Nouveau formulaire
        </button>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(300px,1fr))", gap:20 }}>
        {forms.map(f => (
          <div key={f.id} style={{ background:"#fff", borderRadius:12, padding:20, boxShadow:"0 2px 12px rgba(0,0,0,0.08)" }}>
            <div style={{ fontWeight:700, fontSize:16, color:"#1B3A8C", marginBottom:6 }}>📋 {f.titre}</div>
            <div style={{ fontSize:13, color:"#888", marginBottom:12 }}>{f.description || "Aucune description"}</div>
            <div style={{ fontSize:12, color:"#aaa" }}>{(f.champs||[]).length} champ(s)</div>
            <div style={{ display:"flex", gap:8, marginTop:12 }}>
              <button onClick={() => { setEditing(f); setForm({ titre:f.titre, description:f.description||"", champs:f.champs||[] }); setShowForm(true); }}
                style={{ flex:1, background:"#F5A800", color:"#fff", border:"none", borderRadius:6, padding:"6px", cursor:"pointer", fontSize:12 }}>✏️ Modifier</button>
              <button onClick={() => { api.delete(`/formulaires/${f.id}`); toast.success("Supprimé"); load(); }}
                style={{ flex:1, background:"#dc3545", color:"#fff", border:"none", borderRadius:6, padding:"6px", cursor:"pointer", fontSize:12 }}>🗑️</button>
            </div>
          </div>
        ))}
      </div>
      {showForm && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center" }}>
          <div style={{ background:"#fff", borderRadius:16, padding:32, width:640, maxHeight:"90vh", overflowY:"auto" }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:20 }}>
              <h2 style={{ color:"#1B3A8C", fontSize:18, fontWeight:700 }}>Constructeur de formulaire</h2>
              <button onClick={() => setShowForm(false)} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer" }}>✕</button>
            </div>
            <form onSubmit={submit}>
              <input placeholder="Titre du formulaire *" value={form.titre} onChange={e => setForm({...form,titre:e.target.value})} required
                style={{ width:"100%", padding:"10px 14px", border:"1px solid #ddd", borderRadius:8, fontSize:14, marginBottom:12 }} />
              <textarea placeholder="Description..." value={form.description} onChange={e => setForm({...form,description:e.target.value})}
                style={{ width:"100%", padding:"10px 14px", border:"1px solid #ddd", borderRadius:8, fontSize:14, marginBottom:20, minHeight:60 }} />
              <div style={{ marginBottom:12, fontWeight:700, color:"#1B3A8C" }}>Champs du formulaire</div>
              {form.champs.map((c,i) => (
                <div key={i} style={{ background:"#f8f9fa", borderRadius:8, padding:14, marginBottom:10 }}>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr auto", gap:8, alignItems:"center" }}>
                    <input placeholder="Nom (clé)" value={c.nom} onChange={e => updateChamp(i,"nom",e.target.value)}
                      style={{ padding:"6px 10px", border:"1px solid #ddd", borderRadius:6, fontSize:13 }} />
                    <input placeholder="Label affiché" value={c.label} onChange={e => updateChamp(i,"label",e.target.value)}
                      style={{ padding:"6px 10px", border:"1px solid #ddd", borderRadius:6, fontSize:13 }} />
                    <select value={c.type} onChange={e => updateChamp(i,"type",e.target.value)}
                      style={{ padding:"6px 10px", border:"1px solid #ddd", borderRadius:6, fontSize:13 }}>
                      {TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                    <button type="button" onClick={() => removeChamp(i)}
                      style={{ background:"#dc3545", color:"#fff", border:"none", borderRadius:6, padding:"6px 10px", cursor:"pointer" }}>✕</button>
                  </div>
                </div>
              ))}
              <button type="button" onClick={addChamp}
                style={{ width:"100%", padding:10, border:"2px dashed #1B3A8C", borderRadius:8, color:"#1B3A8C", background:"none", cursor:"pointer", fontWeight:700, marginBottom:20 }}>
                + Ajouter un champ
              </button>
              <div style={{ display:"flex", gap:12, justifyContent:"flex-end" }}>
                <button type="button" onClick={() => setShowForm(false)} style={{ padding:"10px 20px", border:"1px solid #ddd", borderRadius:8, cursor:"pointer" }}>Annuler</button>
                <button type="submit" style={{ padding:"10px 24px", background:"#1B3A8C", color:"#fff", border:"none", borderRadius:8, fontWeight:700, cursor:"pointer" }}>Enregistrer</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
